module.exports = __webpack_public_path__ + "img/vz-styling-icons-link.88ff3c9c.svg";